// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Text CSS Classes
| Note:
|   Requires including the ez-body.css before this file due to
|   dependencies upon css variables.
=================================================================== */
:root {
  /* Font Family Variables */
  /*
  --ezFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;
  --ezTextFontFamily: 'Font-Family-ezClocker', 'Noto Sans', 'Roboto', 'Verdana', 'Arial', sans-serif;
  */
  /* Banner Text Variables */
  --ezBannerHeaderFontSize: 32pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezBannerHeaderColor: var(--ezClockerBlack);
  --ezBannerHeaderFontWeight: bold;
  --ezBannerHeaderFontStyle: normal;
  /* Header Text Variables */
  --ezHeaderFontSize: 22pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezHeaderFontColor: var(--ezClockerBlack);
  --ezHeaderFontWeight: bold;
  --ezHeaderFontStyle: normal;
  /* Title Text Variables */
  --ezTitleFontSize: 18pt;
  --ezTitleFontColor: var(--ezClockerNavy);
  --ezTitleFontWeight: bold;
  --ezTitleFontStyle: normal;
  /* Topic Text Variables */
  --ezTopicFontSize: 14pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezTopicFontColor: var(--ezClockerBlack);
  /* Color: #ffffff, --ezClockerWhite defined in ez-body.css */
  --ezTopicFontColorWhite: var(--ezClockerWhite);
  --ezTopicFontWeight: bold;
  --ezTopicFontStyle: normal;
  /* Action Text Variables */
  --ezActionFontSize: 14pt;
  /* Color: #2419b2, --ezClockerBlue defined in ez-body.css */
  --ezActionFontColor: var(--ezClockerBlue);
  --ezActionFontWeight: bold;
  --ezActionFontStyle: normal;
  /* Normal Text Variables */
  --ezFontSize: 14pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezFontColor: var(--ezClockerBlack);
  /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */
  --ezLightFontColor: var(--ezClockerGray);
  --ezFontWeight: normal;
  --ezFontStyle: normal;
  /* Content Text Variables */
  --ezContentFontSize: 12pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezContentFontColor: var(--ezClockerBlack);
  /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */
  --ezContentLightFontColor: var(--ezClockerGray);
  --ezContentFontWeight: normal;
  --ezContentFontStyle: normal;
  /* Small Text Variables */
  --ezSmallFontSize: 10pt;
  --ezMicroFontSize: 8pt;
  --ezMicroFontWeight: normal;
  --ezMicroFontStyle: normal;
  /* Data Related Text Variables */
  /* Color: --ezClockerNavy: #0f4777;, --ezClockerNavyRGB: rgb(15, 71, 119) */
  --ezDataColorNavy: var(--ezClockerNavy);
  /* State or Status Related Text Variables
  /* Color: #00B945, --ezClockerGreen defined in ez-body.css */
  --ezActiveStateColor: var(--ezClockerGreen);
  /* Color: #ffc500, --ezClockerYellow defined in ez-body.css */
  --ezWarnningStateYellow: var(--ezClockerWarnning);
  /* Color: #9b0400, --ezClockerWarnning defined in ez-body.css */
  --ezWarnningStateRed: var(--ezClockerWarnning);
}

li {
  margin-bottom: 4px;
}

/* Header Text Styles */
h1,
.ezText-h1-32pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  /* ezBannerHeaderColor defined above */
  color: var(--ezBannerHeaderColor);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h1-32pt-ezClockerNavy {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerNavy defined in ez-body.css */
  color: var(--ezClockerNavy);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h1-32pt-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerWhite defined in ez-body.css */
  color: var(--ezClockerWhite);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

h2,
.ezText-h2-22pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezHeaderFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

h3,
.ezText-h3-18pt-ezClockerNavy {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h3-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

h4,
.ezText-h4-14pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTopicFontColor);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  font-family: var(--ezFontFamily);
}

.ezText-h4-12pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTopicFontColor);
  font-size: 12pt;
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  font-family: var(--ezFontFamily);
}

.ezText-main-dialog-message {
  color: var(--ezClockerNavy);
  font-size: 12pt;
  font-weight: bold;
  font-style: normal;
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

/* Header Styles */
.ezH1 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezBannerHeaderColor);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH1-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWhite);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH2 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezHeaderFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH2-subheader {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWhite);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3_warning {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWarnning);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH4 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTopicFontColor);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH4ActionBlue {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezActionFontColor);
  font-size: var(--ezActionFontSize);
  font-weight: var(--ezActionFontWeight);
  font-style: var(--ezActionFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

/* Text Alignment Styles */
.ezAlignRight {
  text-align: right;
}

.ezAlignLeft {
  text-align: left;
}

.ezAlignCenter {
  text-align: center;
}

.ezVerticalAlignTop {
  vertical-align: top;
}

.ezVerticalAlignMiddle {
  vertical-align: middle;
}

.ezVerticalAlignBottom {
  vertical-align: bottom;
}

/* Text Label Styles */
.ezLabel {
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

.ezLabel-above-input {
  display: block;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

.ezDisabledLabel {
  /* --ezClockerStone: #c0c0c0; (defined in ez-body.css) */
  color: var(--ezClockerStone);
}

.ezLabel-scale-80 {
  scale: 80%;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

/* Text Weight Styles */
.ezBold {
  font-weight: bold;
}

.ezText-strike-out {
  text-decoration: line-through;
}

.ezText-overline {
  text-decoration: overline;
}

.ezText-underline {
  text-decoration: underline;
}

/* Special Text Styles */
.ez-faded-error-details {
  color: var(--ezLightFontColor);
  font-family: var(--ezInputMonospaceFontFamily);
  font-size: var(--ezSmallFontSize);
  font-style: italic;
}

.ezText-legal-disclaimer {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezMicroFontSize);
  font-style: italic;
}

.ezText-username-info {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezSmallFontSize);
}

/* Text Classes */
.ezText-bold {
  font-family: var(--ezFontFamily);
  font-weight: bold;
}

.ezText-data-navy {
  color: var(--ezDataColorNavy);
  font-family: var(--ezFontFamily);
  font-weight: normal;
}

.ezText-navy {
  color: var(--ezDataColorNavy);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-black {
  color: var(--ezClockerBlack);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-bold-ezClockerBlack {
  color: var(--ezClockerBlack);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-banner-size-32pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezBannerHeaderFontSize);
}

.ezText-header-size-22pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezHeaderFontSize);
}

.ezText-title-size-18pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezTitleFontSize);
}

.ezText-topic-size-14pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
}

.ezText-content-size-12pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
}

.ezText-small-size-10pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezSmallFontSize);
}

.ezText-micro-size-8pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezMicroFontSize);
}

/* Small Text Classes */
/* Small Black */
.ezText-small-black {
  /* --ezClockerBlack: #000000; (defined in ez-body.css) */
  color: var(--ezClockerBlack);
  font-size: var(--ezSmallFontSize);
}

/* Small White */
.ezText-small-white {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezSmallFontSize);
}

/* Small Gray */
.ezText-small-gray {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezSmallFontSize);
}

/* Small Navy */
.ezText-small-navy {
  /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */
  color: var(--ezClockerNavy);
  font-size: var(--ezSmallFontSize);
}

/* Micro Text Classes */
/* Micro Black */
.ezText-micro-black {
  /* --ezClockerBlack: #000000; (defined in ez-body.css) */
  color: var(--ezClockerBlack);
  font-size: var(--ezMicroFontSize);
}

/* Micro Gray */
.ezText-micro-gray {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezMicroFontSize);
}

/* Micro Navy */
.ezText-micro-navy {
  /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */
  color: var(--ezDataColorNavy);
  font-size: var(--ezMicroFontSize);
}

/* Micro Navy */
.ezText-micro-white {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezMicroFontSize);
}

.ezText-error-ezDarkAlertRed {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezDarkAlertRed);
}

.ezText-success-ezClockerGreen {
  /* --ezClockerGreen: #00B945; (defined in ez-body.css) */
  color: var(--ezClockerGreen);
}

.ezText-radio-checkbox-label {
  cursor: pointer;
}

.ezText-ezActiveStatusColor {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezActiveStateColor);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-ezWarningStatusColor {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezWarnningStateYellow);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-ezErrorStatusColor,
.ezText-ezClockerWarnning,
.ezText-warning-dark-alert-red {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezWarnningStateRed);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-debug-id {
  opacity: 80%;
  font-size: 8pt;
  font-weight: normal;
}

u.ezText-underline-hide-alt-key-up {
  text-decoration: none;
  font-weight: unset;
}

u.ezText-underline-show-alt-key-down {
  text-decoration: underline;
  font-weight: bold;
}

.ezText-italic {
  font-style: italic;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Horizontal Rule Separator Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
hr.ezText-separator-line-navy {
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 2px;
  /* Ignoring hint: Do not use width or height when using padding or border */
  height: 2px;
  background-color: var(--ezClockerNavy);
  border-color: var(--ezClockerNavy);
  /* Ignoring hint: Do not use width or height when using padding or border */
  border-style: solid;
  /* Ignoring hint: Do not use width or height when using padding or border */
  border-width: 1px;
  border-radius: 2px;
}

/* ------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)
------------------------------------------------------------------ */
/*
@media screen and (max-width: 1023px) {
}
*/
/* ------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)
------------------------------------------------------------------ */
/*
@media screen and (max-width: 768px) {
}
*/
/* ------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* ------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezH2 {
    margin-top: 2px;
    margin-bottom: 2px;
    color: var(--ezHeaderFontColor);
    font-size: 14pt;
    font-weight: var(--ezHeaderFontWeight);
    font-style: var(--ezHeaderFontStyle);
    font-family: var(--ezFontFamily);
  }
  .ezH2-subheader {
    margin-top: 2px;
    margin-bottom: 2px;
    color: var(--ezTitleFontColor);
    font-size: 14pt;
    font-weight: var(--ezHeaderFontWeight);
    font-style: var(--ezHeaderFontStyle);
    font-family: var(--ezFontFamily);
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-text.css"],"names":[],"mappings":"AAAA;;;;;qEAAA;AAOA;EACI,0BAAA;EACA;;;GAAA;EAKA,0BAAA;EACA,8BAAA;EACA,4DAAA;EACA,4CAAA;EACA,gCAAA;EACA,iCAAA;EAEA,0BAAA;EACA,wBAAA;EACA,4DAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;EACA,0BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,4DAAA;EACA,yCAAA;EACA,4DAAA;EACA,8CAAA;EACA,yBAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wBAAA;EACA,2DAAA;EACA,yCAAA;EACA,0BAAA;EACA,2BAAA;EAEA,0BAAA;EACA,kBAAA;EACA,4DAAA;EACA,oCAAA;EACA,2DAAA;EACA,wCAAA;EACA,sBAAA;EACA,qBAAA;EAEA,2BAAA;EACA,yBAAA;EACA,4DAAA;EACA,2CAAA;EACA,2DAAA;EACA,+CAAA;EACA,6BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;EAEA,gCAAA;EACA,2EAAA;EACA,uCAAA;EAEA;8DAAA;EAEA,2CAAA;EACA,6DAAA;EACA,iDAAA;EACA,+DAAA;EACA,8CAAA;AAVJ;;AAaA;EACI,kBAAA;AAVJ;;AAaA,uBAAA;AACA;;EAEI,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,iCAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA,kBAAA;AACA;EACI,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA,0BAAA;AACA;EACI,iBAAA;AAVJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,kBAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,sBAAA;AAVJ;;AAaA;EACI,sBAAA;AAVJ;;AAaA,sBAAA;AACA;EACI,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAaA;EACI,cAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAaA;EACI,wDAAA;EACA,4BAAA;AAVJ;;AAaA;EACI,UAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAcA,uBAAA;AACA;EACI,iBAAA;AAXJ;;AAcA;EACI,6BAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,0BAAA;AAXJ;;AAcA,wBAAA;AACA;EACI,8BAAA;EACA,8CAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAXJ;;AAcA,iBAAA;AAEA;EACI,gCAAA;EACA,iBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,gCAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,2EAAA;EACA,gCAAA;AAZJ;;AAgBA;EACI,4BAAA;EACA,2EAAA;EACA,gCAAA;AAbJ;;AAgBA;EACI,4BAAA;EACA,2EAAA;EACA,gCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,wCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,kCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,mCAAA;AAbJ;;AAgBA;EACI,4EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,4EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA,uBAAA;AAEA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAdJ;;AAiBA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAdJ;;AAiBA,uBAAA;AAEA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,uDAAA;EACA,6BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,4BAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,4BAAA;AAfJ;;AAkBA;EACI,eAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,gCAAA;EACA,2EAAA;EACA,gCAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAfJ;;AAkBA;;;EAKI,wDAAA;EACA,gCAAA;EACA,2EAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,qBAAA;EACA,kBAAA;AAjBJ;;AAoBA;EACI,0BAAA;EACA,iBAAA;AAjBJ;;AAoBA;EACI,kBAAA;AAjBJ;;AAqBA;;oEAAA;AAGA;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,2EAAA;EACA,WAAA;EACA,sCAAA;EACA,kCAAA;EACA,2EAAA;EACA,mBAAA;EACA,2EAAA;EACA,iBAAA;EACA,kBAAA;AAlBJ;;AAqBA;;oEAAA;AAGA;;;CAAA;AAKA;;oEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;EACI;IACI,eAAA;IACA,kBAAA;IACA,+BAAA;IACA,eAAA;IACA,sCAAA;IACA,oCAAA;IACA,gCAAA;EArBN;EAwBE;IACI,eAAA;IACA,kBAAA;IACA,8BAAA;IACA,eAAA;IACA,sCAAA;IACA,oCAAA;IACA,gCAAA;EAtBN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Text CSS Classes\r\n| Note:\r\n|   Requires including the ez-body.css before this file due to\r\n|   dependencies upon css variables.\r\n=================================================================== */\r\n\r\n:root {\r\n    /* Font Family Variables */\r\n    /*\r\n    --ezFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;\r\n    --ezTextFontFamily: 'Font-Family-ezClocker', 'Noto Sans', 'Roboto', 'Verdana', 'Arial', sans-serif;\r\n    */\r\n\r\n    /* Banner Text Variables */\r\n    --ezBannerHeaderFontSize: 32pt;\r\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\r\n    --ezBannerHeaderColor: var(--ezClockerBlack);\r\n    --ezBannerHeaderFontWeight: bold;\r\n    --ezBannerHeaderFontStyle: normal;\r\n\r\n    /* Header Text Variables */\r\n    --ezHeaderFontSize: 22pt;\r\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\r\n    --ezHeaderFontColor: var(--ezClockerBlack);\r\n    --ezHeaderFontWeight: bold;\r\n    --ezHeaderFontStyle: normal;\r\n\r\n    /* Title Text Variables */\r\n    --ezTitleFontSize: 18pt;\r\n    --ezTitleFontColor: var(--ezClockerNavy);\r\n    --ezTitleFontWeight: bold;\r\n    --ezTitleFontStyle: normal;\r\n\r\n    /* Topic Text Variables */\r\n    --ezTopicFontSize: 14pt;\r\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\r\n    --ezTopicFontColor: var(--ezClockerBlack);\r\n    /* Color: #ffffff, --ezClockerWhite defined in ez-body.css */\r\n    --ezTopicFontColorWhite: var(--ezClockerWhite);\r\n    --ezTopicFontWeight: bold;\r\n    --ezTopicFontStyle: normal;\r\n\r\n    /* Action Text Variables */\r\n    --ezActionFontSize: 14pt;\r\n    /* Color: #2419b2, --ezClockerBlue defined in ez-body.css */\r\n    --ezActionFontColor: var(--ezClockerBlue);\r\n    --ezActionFontWeight: bold;\r\n    --ezActionFontStyle: normal;\r\n\r\n    /* Normal Text Variables */\r\n    --ezFontSize: 14pt;\r\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\r\n    --ezFontColor: var(--ezClockerBlack);\r\n    /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */\r\n    --ezLightFontColor: var(--ezClockerGray);\r\n    --ezFontWeight: normal;\r\n    --ezFontStyle: normal;\r\n\r\n    /* Content Text Variables */\r\n    --ezContentFontSize: 12pt;\r\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\r\n    --ezContentFontColor: var(--ezClockerBlack);\r\n    /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */\r\n    --ezContentLightFontColor: var(--ezClockerGray);\r\n    --ezContentFontWeight: normal;\r\n    --ezContentFontStyle: normal;\r\n\r\n    /* Small Text Variables */\r\n    --ezSmallFontSize: 10pt;\r\n    --ezMicroFontSize: 8pt;\r\n    --ezMicroFontWeight: normal;\r\n    --ezMicroFontStyle: normal;\r\n\r\n    /* Data Related Text Variables */\r\n    /* Color: --ezClockerNavy: #0f4777;, --ezClockerNavyRGB: rgb(15, 71, 119) */\r\n    --ezDataColorNavy: var(--ezClockerNavy);\r\n\r\n    /* State or Status Related Text Variables\r\n    /* Color: #00B945, --ezClockerGreen defined in ez-body.css */\r\n    --ezActiveStateColor: var(--ezClockerGreen);\r\n    /* Color: #ffc500, --ezClockerYellow defined in ez-body.css */\r\n    --ezWarnningStateYellow: var(--ezClockerWarnning);\r\n    /* Color: #9b0400, --ezClockerWarnning defined in ez-body.css */\r\n    --ezWarnningStateRed: var(--ezClockerWarnning);\r\n}\r\n\r\nli {\r\n    margin-bottom: 4px;\r\n}\r\n\r\n/* Header Text Styles */\r\nh1,\r\n.ezText-h1-32pt-ezClockerBlack {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    /* ezBannerHeaderColor defined above */\r\n    color: var(--ezBannerHeaderColor);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-h1-32pt-ezClockerNavy {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    /* --ezClockerNavy defined in ez-body.css */\r\n    color: var(--ezClockerNavy);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-h1-32pt-ezClockerWhite {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    /* --ezClockerWhite defined in ez-body.css */\r\n    color: var(--ezClockerWhite);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    /* ezBannerHeaderColor defined above */\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\nh2,\r\n.ezText-h2-22pt-ezClockerBlack {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezHeaderFontColor);\r\n    font-size: var(--ezHeaderFontSize);\r\n    font-weight: var(--ezHeaderFontWeight);\r\n    font-style: var(--ezHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\nh3,\r\n.ezText-h3-18pt-ezClockerNavy {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTitleFontColor);\r\n    font-size: var(--ezTitleFontSize);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-style: var(--ezTitleFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-h3-ezClockerBlack {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    /* --ezClockerBlack defined in ez-body.css */\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezTitleFontSize);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-style: var(--ezTitleFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\nh4,\r\n.ezText-h4-14pt-ezClockerBlack {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTopicFontColor);\r\n    font-size: var(--ezTopicFontSize);\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-h4-12pt-ezClockerBlack {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTopicFontColor);\r\n    font-size: 12pt;\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-main-dialog-message {\r\n    color: var(--ezClockerNavy);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    font-style: normal;\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n/* Header Styles */\r\n.ezH1 {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezBannerHeaderColor);\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH1-ezClockerWhite {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH2 {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezHeaderFontColor);\r\n    font-size: var(--ezHeaderFontSize);\r\n    font-weight: var(--ezHeaderFontWeight);\r\n    font-style: var(--ezHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH2-subheader {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTitleFontColor);\r\n    font-size: var(--ezHeaderFontSize);\r\n    font-weight: var(--ezHeaderFontWeight);\r\n    font-style: var(--ezHeaderFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH3 {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTitleFontColor);\r\n    font-size: var(--ezTitleFontSize);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-style: var(--ezTitleFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH3-ezClockerWhite {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezTitleFontSize);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-style: var(--ezTitleFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH3_warning {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezClockerWarnning);\r\n    font-size: var(--ezTitleFontSize);\r\n    font-weight: var(--ezTitleFontWeight);\r\n    font-style: var(--ezTitleFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH4 {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezTopicFontColor);\r\n    font-size: var(--ezTopicFontSize);\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezH4ActionBlue {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    color: var(--ezActionFontColor);\r\n    font-size: var(--ezActionFontSize);\r\n    font-weight: var(--ezActionFontWeight);\r\n    font-style: var(--ezActionFontStyle);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n/* Text Alignment Styles */\r\n.ezAlignRight {\r\n    text-align: right;\r\n}\r\n\r\n.ezAlignLeft {\r\n    text-align: left;\r\n}\r\n\r\n.ezAlignCenter {\r\n    text-align: center;\r\n}\r\n\r\n.ezVerticalAlignTop {\r\n    vertical-align: top;\r\n}\r\n\r\n.ezVerticalAlignMiddle {\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezVerticalAlignBottom {\r\n    vertical-align: bottom;\r\n}\r\n\r\n/* Text Label Styles */\r\n.ezLabel {\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-style: var(--ezContentFontStyle);\r\n    font-weight: var(--ezContentFontWeight);\r\n}\r\n\r\n.ezLabel-above-input {\r\n    display: block;\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-style: var(--ezContentFontStyle);\r\n    font-weight: var(--ezContentFontWeight);\r\n}\r\n\r\n.ezDisabledLabel {\r\n    /* --ezClockerStone: #c0c0c0; (defined in ez-body.css) */\r\n    color: var(--ezClockerStone);\r\n}\r\n\r\n.ezLabel-scale-80 {\r\n    scale: 80%;\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-style: var(--ezContentFontStyle);\r\n    font-weight: var(--ezContentFontWeight);\r\n}\r\n\r\n\r\n/* Text Weight Styles */\r\n.ezBold {\r\n    font-weight: bold;\r\n}\r\n\r\n.ezText-strike-out {\r\n    text-decoration: line-through;\r\n}\r\n\r\n.ezText-overline {\r\n    text-decoration: overline;\r\n}\r\n\r\n.ezText-underline {\r\n    text-decoration: underline;\r\n}\r\n\r\n/* Special Text Styles */\r\n.ez-faded-error-details {\r\n    color: var(--ezLightFontColor);\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    font-size: var(--ezSmallFontSize);\r\n    font-style: italic;\r\n}\r\n\r\n.ezText-legal-disclaimer {\r\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\r\n    color: var(--ezClockerGray);\r\n    font-size: var(--ezMicroFontSize);\r\n    font-style: italic;\r\n}\r\n\r\n.ezText-username-info {\r\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n/* Text Classes */\r\n\r\n.ezText-bold {\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: bold;\r\n}\r\n\r\n.ezText-data-navy {\r\n    color: var(--ezDataColorNavy);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: normal;\r\n}\r\n\r\n.ezText-navy {\r\n    color: var(--ezDataColorNavy);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n\r\n}\r\n\r\n.ezText-black {\r\n    color: var(--ezClockerBlack);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-bold-ezClockerBlack {\r\n    color: var(--ezClockerBlack);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-banner-size-32pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n}\r\n\r\n.ezText-header-size-22pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezHeaderFontSize);\r\n}\r\n\r\n.ezText-title-size-18pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezTitleFontSize);\r\n}\r\n\r\n.ezText-topic-size-14pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezTopicFontSize);\r\n}\r\n\r\n.ezText-content-size-12pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n}\r\n\r\n.ezText-small-size-10pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n.ezText-micro-size-8pt {\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezMicroFontSize);\r\n}\r\n\r\n/* Small Text Classes */\r\n\r\n/* Small Black */\r\n.ezText-small-black {\r\n    /* --ezClockerBlack: #000000; (defined in ez-body.css) */\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n/* Small White */\r\n.ezText-small-white {\r\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n/* Small Gray */\r\n.ezText-small-gray {\r\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\r\n    color: var(--ezClockerGray);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n/* Small Navy */\r\n.ezText-small-navy {\r\n    /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */\r\n    color: var(--ezClockerNavy);\r\n    font-size: var(--ezSmallFontSize);\r\n}\r\n\r\n/* Micro Text Classes */\r\n\r\n/* Micro Black */\r\n.ezText-micro-black {\r\n    /* --ezClockerBlack: #000000; (defined in ez-body.css) */\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezMicroFontSize);\r\n}\r\n\r\n/* Micro Gray */\r\n.ezText-micro-gray {\r\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\r\n    color: var(--ezClockerGray);\r\n    font-size: var(--ezMicroFontSize);\r\n}\r\n\r\n/* Micro Navy */\r\n.ezText-micro-navy {\r\n    /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */\r\n    color: var(--ezDataColorNavy);\r\n    font-size: var(--ezMicroFontSize);\r\n}\r\n\r\n/* Micro Navy */\r\n.ezText-micro-white {\r\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezMicroFontSize);\r\n}\r\n\r\n.ezText-error-ezDarkAlertRed {\r\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\r\n    color: var(--ezDarkAlertRed);\r\n}\r\n\r\n.ezText-success-ezClockerGreen {\r\n    /* --ezClockerGreen: #00B945; (defined in ez-body.css) */\r\n    color: var(--ezClockerGreen);\r\n}\r\n\r\n.ezText-radio-checkbox-label {\r\n    cursor: pointer;\r\n}\r\n\r\n.ezText-ezActiveStatusColor {\r\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\r\n    color: var(--ezActiveStateColor);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-ezWarningStatusColor {\r\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\r\n    color: var(--ezWarnningStateYellow);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-ezErrorStatusColor,\r\n/* deprecated */\r\n.ezText-ezClockerWarnning,\r\n/* deprecated */\r\n.ezText-warning-dark-alert-red {\r\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\r\n    color: var(--ezWarnningStateRed);\r\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\r\n    font-family: var(--ezFontFamily);\r\n}\r\n\r\n.ezText-debug-id {\r\n    opacity: 80%;\r\n    font-size: 8pt;\r\n    font-weight: normal;\r\n}\r\n\r\nu.ezText-underline-hide-alt-key-up {\r\n    text-decoration: none;\r\n    font-weight: unset;\r\n}\r\n\r\nu.ezText-underline-show-alt-key-down {\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n}\r\n\r\n.ezText-italic {\r\n    font-style: italic;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Horizontal Rule Separator Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nhr.ezText-separator-line-navy {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    min-height: 2px;\r\n    /* Ignoring hint: Do not use width or height when using padding or border */\r\n    height: 2px;\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezClockerNavy);\r\n    /* Ignoring hint: Do not use width or height when using padding or border */\r\n    border-style: solid;\r\n    /* Ignoring hint: Do not use width or height when using padding or border */\r\n    border-width: 1px;\r\n    border-radius: 2px;\r\n}\r\n\r\n/* ------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)\r\n------------------------------------------------------------------ */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* ------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)\r\n------------------------------------------------------------------ */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* ------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}\r\n*/\r\n\r\n/* ------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n    .ezH2 {\r\n        margin-top: 2px;\r\n        margin-bottom: 2px;\r\n        color: var(--ezHeaderFontColor);\r\n        font-size: 14pt;\r\n        font-weight: var(--ezHeaderFontWeight);\r\n        font-style: var(--ezHeaderFontStyle);\r\n        font-family: var(--ezFontFamily);\r\n    }\r\n\r\n    .ezH2-subheader {\r\n        margin-top: 2px;\r\n        margin-bottom: 2px;\r\n        color: var(--ezTitleFontColor);\r\n        font-size: 14pt;\r\n        font-weight: var(--ezHeaderFontWeight);\r\n        font-style: var(--ezHeaderFontStyle);\r\n        font-family: var(--ezFontFamily);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
